var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useCallback, useContext, useState, } from 'react';
import { useShipping } from './Shipping';
import { useBilling } from './Billing';
import { useCard } from './Card';
import { useEmail } from './Email';
import { usePayment } from './Payment';
import { useRebilly } from './Rebilly';
import { createPaymentToken } from '../../../utils/createPaymentToken';
import { addError } from '../../../utils/form';
import { createTransaction } from '../../../utils/createTransaction';
import { useCartCheckoutItems, useCartShippingAmount, useCartRequiresShipping } from './Cart';
import { useBillingIsSame } from './BillingIsSame';
import { useToggles } from './Toggles';
import { useCustomJson } from './CustomJson';
var SubmitContext = createContext(null);
export var SubmitProvider = function (props) {
    var config = useRebilly();
    var _a = useState(false), submitting = _a[0], setSubmitting = _a[1];
    var billingIsSame = useBillingIsSame().billingIsSame;
    var requiresShipping = useCartRequiresShipping();
    var shippingAmount = useCartShippingAmount();
    var items = useCartCheckoutItems();
    var getFirstError = useGetFirstError();
    var paymentCtx = usePayment();
    var emailCtx = useEmail();
    var shippingCtx = useShipping();
    var billingCtx = useBilling();
    var cardCtx = useCard();
    var togglesCtx = useToggles();
    var _b = useCustomJson(), customJson = _b.customJson, getCustomJson = _b.getCustomJson;
    var incomplete = !togglesCtx.allChecked ||
        emailCtx.incomplete ||
        cardCtx.incomplete ||
        (requiresShipping ? shippingCtx.incomplete || (!billingIsSame && billingCtx.incomplete) : billingCtx.incomplete);
    var handleCreatePaymentToken = function (values) { return __awaiter(void 0, void 0, void 0, function () {
        var params, token, _i, _a, invalid, ctx, element, errorEl;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    params = buildPaymentTokenParams(values);
                    return [4 /*yield*/, createPaymentToken(config, params)];
                case 1:
                    token = _b.sent();
                    if (token.invalidFields) {
                        for (_i = 0, _a = token.invalidFields; _i < _a.length; _i++) {
                            invalid = _a[_i];
                            ctx = invalid.field.startsWith('paymentInstrument')
                                ? cardCtx
                                : invalid.field.startsWith('billingAddress')
                                    ? billingIsSame
                                        ? shippingCtx
                                        : billingCtx
                                    : null;
                            if (ctx) {
                                element = paymentCtx.findField(invalid.field);
                                if (element) {
                                    ctx.setErrorMessage(element.name, invalid.message);
                                    addError(element);
                                }
                            }
                        }
                        errorEl = getFirstError();
                        if (errorEl && typeof errorEl.focus === 'function') {
                            errorEl.focus();
                        }
                        throw new Error(token.detail);
                    }
                    return [2 /*return*/, token];
            }
        });
    }); };
    var handleCheckout = function (variables) { return __awaiter(void 0, void 0, void 0, function () {
        var purchase, err_1, error;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, 3, 4]);
                    if (submitting)
                        return [2 /*return*/];
                    setSubmitting(true);
                    if (props.onPurchaseAttempted) {
                        props.onPurchaseAttempted(variables);
                    }
                    return [4 /*yield*/, createTransaction(config, __assign({ items: items, shippingAmount: shippingAmount }, variables))];
                case 1:
                    purchase = _a.sent();
                    if (props.onPurchaseCompleted) {
                        props.onPurchaseCompleted(purchase);
                    }
                    return [3 /*break*/, 4];
                case 2:
                    err_1 = _a.sent();
                    error = err_1;
                    console.log('Sumbit checkout error', error);
                    if (props.onPurchaseFailed) {
                        props.onPurchaseFailed(error);
                    }
                    return [3 /*break*/, 4];
                case 3:
                    setSubmitting(false);
                    return [7 /*endfinally*/];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var handleSubmit = function (ev) { return __awaiter(void 0, void 0, void 0, function () {
        var values, submittable, errorEl, token, variables, purchase, err_2, error;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    ev.preventDefault();
                    if (submitting)
                        return [2 /*return*/];
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 4, 5, 6]);
                    values = paymentCtx.getValuesOrErrors();
                    submittable = true;
                    errorEl = getFirstError();
                    if (errorEl && typeof errorEl.focus === 'function') {
                        errorEl.focus();
                        submittable = false;
                    }
                    if (!togglesCtx.allChecked) {
                        togglesCtx.showRequiredErrors();
                        submittable = false;
                    }
                    if (!submittable)
                        return [2 /*return*/];
                    setSubmitting(true);
                    return [4 /*yield*/, handleCreatePaymentToken(values)];
                case 2:
                    token = _a.sent();
                    variables = buildCheckoutVariables(values, token.id, requiresShipping);
                    if (props.onPurchaseAttempted) {
                        props.onPurchaseAttempted(variables);
                    }
                    return [4 /*yield*/, createTransaction(config, __assign({ items: items, shippingAmount: shippingAmount, customJson: __assign(__assign({}, customJson), getCustomJson()) }, variables))];
                case 3:
                    purchase = _a.sent();
                    if (props.onPurchaseCompleted) {
                        props.onPurchaseCompleted(purchase);
                    }
                    return [3 /*break*/, 6];
                case 4:
                    err_2 = _a.sent();
                    error = err_2;
                    console.log('Sumbit checkout error', error);
                    if (props.onPurchaseFailed) {
                        props.onPurchaseFailed(error);
                    }
                    return [3 /*break*/, 6];
                case 5:
                    setSubmitting(false);
                    return [7 /*endfinally*/];
                case 6: return [2 /*return*/];
            }
        });
    }); };
    return (_jsx(SubmitContext.Provider, __assign({ value: {
            incomplete: incomplete,
            submitting: submitting,
            handleSubmit: handleSubmit,
            handleCheckout: handleCheckout,
            nextText: props.nextText || 'Next',
            submitText: props.submitText || 'Pay',
            submittingText: props.submittingText || 'Processing...',
            submitHelperTextTop: props.submitHelperTextTop,
            submitHelperTextBottom: props.submitHelperTextBottom,
        } }, { children: props.children })));
};
export var useSubmit = function () {
    var context = useContext(SubmitContext);
    if (!context)
        throw new Error('SubmitProvider not found in root');
    return context;
};
export var useGetFirstError = function () {
    var paymentRef = usePayment().paymentRef;
    return useCallback(function () {
        var _a;
        var firstError = (_a = paymentRef.current) === null || _a === void 0 ? void 0 : _a.querySelector('[error=true]');
        return firstError;
    }, [paymentRef]);
};
function buildPaymentTokenParams(_a) {
    var shipping = _a.shipping, billing = _a.billing, card = _a.card, email = _a.email;
    var _b = getNames(billing.values.billingName || shipping.values.name || ''), firstName = _b.firstName, lastName = _b.lastName;
    var country = billing.values.billingCountry || shipping.values.country || '';
    var postalCode = billing.values.billingZip || shipping.values.zip || '';
    var pan = card.values.cardNumber || '';
    var expiry = card.values.cardExpiry || '';
    var expMonth = Number(expiry.slice(0, 2)) || 0;
    var expYear = Number(expiry.slice(2)) || 0;
    var cvv = card.values.cardCvc || '';
    return {
        method: 'payment-card',
        paymentInstrument: {
            pan: pan,
            cvv: cvv,
            expMonth: expMonth,
            expYear: expYear,
        },
        billingAddress: {
            firstName: firstName,
            lastName: lastName,
            country: country,
            postalCode: postalCode,
        },
    };
}
function buildCheckoutVariables(values, paymentToken, requiresShipping) {
    var email = values.email.values.email || '';
    var names = getNames(values.shipping.values.name || values.billing.values.billingName || '');
    var variables = {
        paymentToken: paymentToken,
        customer: __assign({ email: email }, names),
    };
    variables.billing = {
        country: values.billing.values.billingCountry || values.shipping.values.country || '',
        postalCode: values.billing.values.billingZip || values.shipping.values.zip || '',
        city: '',
        region: '',
        address: '',
        address2: '',
    };
    if (requiresShipping) {
        variables.shipping = {
            country: values.shipping.values.country || '',
            postalCode: values.shipping.values.zip || '',
            city: values.shipping.values.city || '',
            region: values.shipping.values.state || '',
            address: values.shipping.values.address || '',
            address2: values.shipping.values.address2 || '',
        };
    }
    return variables;
}
function getNames(name) {
    var names = name.split(' ');
    var firstName = names[0] || '';
    var lastName = names[1] || '';
    return {
        firstName: firstName,
        lastName: lastName,
    };
}
//# sourceMappingURL=Submit.js.map